import { atom, useAtom } from "jotai";

export type Tab = "upload" | "products" | "size" | "front" | "back" | "design";

const visitedTabsAtom = atom<Set<Tab>>(new Set<Tab>());

export const useVisitedTabs = () => useAtom(visitedTabsAtom);
